import { travelerForm } from '@eti/travelers';
export const getTravelerGender = (form, state, travelers) => travelers.map((traveler, index) => ({
  gender: travelerForm.getSelectedGender(form)(state, index) || ''
}));
//# sourceMappingURL=travelerGender.js.map